import { produce } from "immer";

export const initialState = {
  selectedWorkspaceForBilling: {},
};

/* eslint-disable default-case, no-param-reassign */
const customBillingReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case "SELECTED_WORKSPACE_FOR_BILLING":
        draft.selectedWorkspaceForBilling = action.payload.data;

        break;
    }
  });

export default customBillingReducer;
